"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePermissionStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.usePermissionStore = (0, pinia_1.defineStore)("permissionStore", {
    state: () => ({
        loading: false,
        permissions: [],
    }),
    getters: {
        permissionGroupped: (state) => {
            const permissions = state.permissions;
            const permissionsGroupped = {};
            permissions.forEach((permission) => {
                const group = String(permission.group).toString();
                if (!permissionsGroupped[group]) {
                    permissionsGroupped[group] = [];
                }
                permissionsGroupped[group].push(permission);
            });
            return permissionsGroupped;
        },
    },
    actions: {
        getPermissions(router, query) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: "permissions_api", query: query })
                    .href)
                    .then((response) => {
                    let permissions = [];
                    if (Array.isArray(response["hydra:member"])) {
                        response["hydra:member"].forEach((element) => {
                            if (element["@type"] !== "Permission") {
                                return;
                            }
                            permissions.push(element);
                        });
                    }
                    this.permissions = permissions;
                    this.loading = false;
                    resolve(response);
                })
                    .catch((error) => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
    },
});
